import { PaymentStatus, TransactionStatus } from '../types/payment.types'

/**
 * Maps the payment status (of pom's paylink) to the transaction status (of the payment)
 *  - Payment status: is the status of the payment in the paylink (cannot be refused)
 *  - Transaction status: is the status of the payment in the payment endpoint (can fail and be refused)
 * @param paymentStatus
 * @returns
 */
export const mapPaymentStatusToTransactionStatus = (paymentStatus: PaymentStatus): TransactionStatus => {
  if (paymentStatus === PaymentStatus.COMPLETED) {
    return TransactionStatus.COMPLETED
  }

  if (paymentStatus === PaymentStatus.UNPAID) {
    return TransactionStatus.PROCESSING
  }

  return TransactionStatus.REFUSED
}

export const mapPriceToCurrency = (price: number) => {
  // Improvement: use the currency from the price object
  return new Intl.NumberFormat('nl-BE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price)
}

export const getCurrencySign = (currency: string) => {
  return currency.toUpperCase() === 'EUR' ? '€' : currency === 'USD' ? '$' : ''
}
